exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".powerpage-tab .store-powerpage[data-v-5b523021]{margin-bottom:30px;float:right}", ""]);

// exports
